import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { ADMIN_AUTH_EVENT, clearAdminSession } from '../services/api';

const ProtectedRoute = ({ children }) => {
  const hasValidToken = () => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      return false;
    }

    try {
      const [, payload] = token.split('.');
      if (!payload) {
        clearAdminSession();
        return false;
      }

      const parsedPayload = JSON.parse(atob(payload));
      if (parsedPayload.exp && Date.now() >= parsedPayload.exp * 1000) {
        clearAdminSession();
        return false;
      }

      return true;
    } catch (error) {
      clearAdminSession();
      return false;
    }
  };

  const [isAuthenticated, setIsAuthenticated] = useState(() => hasValidToken());

  useEffect(() => {
    const syncAuthState = () => setIsAuthenticated(hasValidToken());

    window.addEventListener('storage', syncAuthState);
    window.addEventListener(ADMIN_AUTH_EVENT, syncAuthState);

    return () => {
      window.removeEventListener('storage', syncAuthState);
      window.removeEventListener(ADMIN_AUTH_EVENT, syncAuthState);
    };
  }, []);

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
